/**
 * @generated SignedSource<<3edab75b0a6be31504235793f2331c36>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSellerItemsCarousel_item$data = {
  readonly seller: {
    readonly isAccessible: boolean | null;
    readonly serviceId: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpSharedSellerItemsCarousel_item";
};
export type PdpSharedSellerItemsCarousel_item$key = {
  readonly " $data"?: PdpSharedSellerItemsCarousel_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSellerItemsCarousel_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSellerItemsCarousel_item",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "687442f77aa11e2a20ee0aee8051faef";

export default node;
